export default __webpack_public_path__ + "static/1292-6ee8b175c179d9dacd5e2a425c9898db.gif";